
import { Navbar, Nav, NavDropdown } from 'react-bootstrap'
import { FaChevronDown, FaBars } from "react-icons/fa"
import { RightSectionNav } from '@group-devs/yfp7-global-modules/components/Block'
import { useState } from 'react'
import { WDropdownNav } from '../Block'
import Link from 'next/link'

const TopNavUser = (props) => {

    const basepath ="/learn-and-earn"

    const [ bg, setBg ] = useState(false)
    const delay = () => {
        if (bg == true){
            setTimeout(() => {
                setBg(!bg)
              }, 300)
        } else {
            setBg(!bg)
        }
    }

    return (
        <Navbar collapseOnSelect expand="xl" onToggle={ delay } className={`dashboardtopnav position-absolute w-100 py-0 ${ bg ? "nav-shadow" : ""} ${ bg ? "bg-white" : "bg-transparent"}`}>
            <WDropdownNav site={props.site} />
            <RightSectionNav avatar={props.site.brand} shop={`${process.env.yfpDomain}shop`} notification={"wellness"} auth={props.auth} site={props.site}/>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" className={` ${ bg ? "text-dark" : "text-white"} border-0 order-xl-3`}><FaBars/></Navbar.Toggle>
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="mr-auto align-items-xl-center order-xl- mt-2">
                    <Link href="/home" passHref><Nav.Link>Home</Nav.Link></Link>
                    <NavDropdown title={<div>Modules <FaChevronDown className="h8 ml-1 "/></div>} id="navModule" className="navModule">
                        <Link href={`${basepath}/modules`} passHref><NavDropdown.Item>Modules</NavDropdown.Item></Link>
                        <Link href={`${basepath}/module-1`} passHref><NavDropdown.Item>Module 1</NavDropdown.Item></Link>
                        <Link href={`${basepath}/module-2`} passHref><NavDropdown.Item>Module 2</NavDropdown.Item></Link>
                        <Link href={`${basepath}/module-3`} passHref><NavDropdown.Item>Module 3</NavDropdown.Item></Link>
                        <Link href={`${basepath}/module-4`} passHref><NavDropdown.Item>Module 4</NavDropdown.Item></Link>
                        <Link href={`${basepath}/module-5`} passHref><NavDropdown.Item>Module 5</NavDropdown.Item></Link>
                        <Link href={`${basepath}/module-6`} passHref><NavDropdown.Item>Module 6</NavDropdown.Item></Link>
                        <Link href={`${basepath}/module-7`} passHref><NavDropdown.Item>Module 7</NavDropdown.Item></Link>
                    </NavDropdown>
                </Nav>
            </Navbar.Collapse>
            
            <style jsx global>{`
                .logoToggle svg{
                    top: .4rem;
                }
                .logoToggle .dropdown-item:active{
                    background-color:transparent
                }
                .dropdown-toggle::after {
                    display: none;
                }
                
                .dashboardtopnav .dropdown-item{
                    font-size:.9rem;
                }
                .navbar-toggler:focus{
                    border:none!important;
                    outline: none!important;
                }
                .navbar-exeption{
                    flex-direction: row;
                }

                .navbar-exeption .nav-link {
                    display: block;
                    padding: .5rem 1rem;
                }

                .nav-shadow .nav-link {
                    color:#232323!important;
                }
               
                .sectiondropdown .dropdown,
                .categoriesdropdown .dropdown{
                    position: inherit;
                }
                .sectiondropdown .dropdown-menu,
                .categoriesdropdown .dropdown-menu{
                    padding:0;
                    width: 100%;
                    min-width:100%;
                    border-radius:0;
                    display:block!important;
                    height:0;
                    transition: height .4s ease-in-out;
                    overflow: hidden;
                    border:none;
                }
                .sectiondropdown .dropdown-menu.show,
                .categoriesdropdown .dropdown-menu.show{
                    height:333px;
                    transition: height .4s ease-in-out
                }
                .sectiondropdown .dropdown-menu row,
                .categoriesdropdown .dropdown-menu row{
                    height:333px;
                    transition: height .4s ease-in-out
                }
                
                .navModule .dropdown-menu{
                    min-width: 7rem!important;
                }
               
            `}</style>
        </Navbar>
    )
}

export default TopNavUser